import { useCallback } from 'react';
import { useI18n } from '@/hooks/useI18n';
import { studyText } from '@/i18n/studyText';
const labels: Record<string, [string, string]> = {
  'Предыдущие сообщения': ['Алдыңғы хабарламалар', 'Earlier messages'],
  'Связь с эдвайзером': ['Эдвайзермен байланыс', 'Contact your advisor'],
  'Эдвайзер пока не назначен. Обратитесь к администратору.': [
    'Эдвайзер әлі тағайындалмаған. Әкімшіге хабарласыңыз.',
    'No advisor assigned yet. Contact the administrator.',
  ],
  'Загрузка…': ['Жүктелуде…', 'Loading…'],
  'Учебный процесс докторантов': ['Докторанттардың оқу процесі', 'Doctoral process'],
  'Закреплённые докторанты': ['Бекітілген докторанттар', 'Assigned doctoral students'],
  'К реестру': ['Тізімге оралу', 'Back to registry'],
  Консультант: ['Кеңесші', 'Consultant'],
  'Написать докторанту': ['Докторантқа жазу', 'Message student'],
  'Назначить встречу': ['Кездесу тағайындау', 'Schedule a meeting'],
  'Не указан': ['Көрсетілмеген', 'Not specified'],
  курс: ['курс', 'year'],
  '1 курс': ['1 курс', 'Year 1'],
  '2 курс': ['2 курс', 'Year 2'],
  '3 курс': ['3 курс', 'Year 3'],
  'Неполные комплекты': ['Толық емес құжаттар', 'Incomplete submissions'],
  'Ближайшие сроки': ['Жақын мерзімдер', 'Upcoming deadlines'],
  'Неполные разделы': ['Толық емес бөлімдер', 'Incomplete sections'],
  'В работе': ['Орындалуда', 'In progress'],
  'Нет докторантов в этой выборке': [
    'Бұл таңдауда докторанттар жоқ',
    'No students match these filters',
  ],
  'Учётная запись не связана. Требуется настройка назначения.': [
    'Тіркелгі байланыстырылмаған. Тағайындауды реттеңіз.',
    'Account is not linked. Assignment needs configuration.',
  ],
  'Утверждённые инструкции и образцы': [
    'Бекітілген нұсқаулықтар мен үлгілер',
    'Approved instructions and templates',
  ],
  'Новая редакция образца': ['Үлгінің жаңа нұсқасы', 'New template edition'],
  'Редакция будет опубликована.': ['Нұсқа жарияланады.', 'This edition will be published.'],
  'Редакция будет передана на утверждение.': [
    'Нұсқа бекітуге жіберіледі.',
    'This edition will be submitted for approval.',
  ],
  'Источник утверждения': ['Бекіту көзі', 'Approval source'],
  Редакция: ['Нұсқа', 'Edition'],
  'Файл образца': ['Үлгі файлы', 'Template file'],
  'История редакций': ['Нұсқалар тарихы', 'Edition history'],
  Утвердить: ['Бекіту', 'Approve'],
  Сообщение: ['Хабарлама', 'Message'],
  Отправить: ['Жіберу', 'Send'],
  Обновить: ['Жаңарту', 'Refresh'],
  Ошибка: ['Қате', 'Error'],
  'Дата и время': ['Күні мен уақыты', 'Date and time'],
  'Место или ссылка': ['Орын немесе сілтеме', 'Location or link'],
  Повестка: ['Күн тәртібі', 'Agenda'],
  Назначить: ['Тағайындау', 'Schedule'],
  'Встреч пока нет': ['Әзірге кездесулер жоқ', 'No meetings yet'],
  PENDING: ['Күтілуде', 'Pending'],
  ACCEPTED: ['Қабылданды', 'Accepted'],
  DECLINED: ['Қабылданбады', 'Declined'],
  COMPLETED: ['Аяқталды', 'Completed'],
  CANCELLED: ['Бас тартылды', 'Cancelled'],
  APPROVED: ['Бекітілген', 'Approved'],
  DRAFT: ['Жоба', 'Draft'],
  NOT_STARTED: ['Басталмаған', 'Not started'],
  SUBMITTED: ['Тексерілуде', 'Submitted'],
  NEEDS_CHANGES: ['Түзету қажет', 'Changes requested'],
  PARTIALLY_ACCEPTED: ['Ішінара қабылданды', 'Partially accepted'],
};
const ru: Record<string, string> = {
  PENDING: 'Ожидает',
  ACCEPTED: 'Принято',
  DECLINED: 'Отклонено',
  COMPLETED: 'Завершено',
  CANCELLED: 'Отменено',
  APPROVED: 'Утверждено',
  DRAFT: 'Черновик',
  NOT_STARTED: 'Не начато',
  SUBMITTED: 'На проверке',
  NEEDS_CHANGES: 'Требуются исправления',
  PARTIALLY_ACCEPTED: 'Частично принято',
};
export function useAdvisorText() {
  const { locale } = useI18n();
  return useCallback(
    (text: string) =>
      locale === 'ru'
        ? ru[text] || text
        : labels[text]?.[locale === 'kz' ? 0 : 1] || studyText(text, locale),
    [locale],
  );
}
